import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看");

import { ref } from 'vue';
import { getVexTableProps, dateFormat } from '@/config';
import { getReportList } from '@/request';
import dayjs from 'dayjs';
import WechatRepoetDetailModal from './component/WechatRepoetDetailModal.vue';
export default {
  name: 'WechatReport',

  setup(__props) {
    const cusSourceList = [{
      label: '全部',
      value: ''
    }, {
      label: '自建',
      value: '2'
    }, {
      label: '万药城',
      value: '1'
    }];
    const showDetail = ref(false);
    const selectRow = ref(null);
    const formRef = ref();
    const form = ref({
      custName: '',
      companyName: '',
      supUser: '',
      supplier: '',
      custSource: '',
      state: '',
      deleteFlag: '',
      endTime: dayjs(Date.now()).format(dateFormat),
      startTime: dayjs(Date.now() - 7 * 24 * 60 * 60 * 1000).format(dateFormat)
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '单据标号',
        field: 'declarationNo',
        width: '200px',
        showOverflow: true
      }, {
        title: '状态',
        field: 'state_text',
        width: '100px',
        showOverflow: true
      }, {
        title: '单据是否删除',
        field: 'deleteFlagText',
        width: '150px',
        showOverflow: true
      }, {
        title: '开票员留言',
        field: 'leaveWord',
        width: '200px',
        showOverflow: true
      }, {
        title: '客户名称',
        field: 'custName',
        width: '150px',
        showOverflow: true
      }, {
        title: '客户来源',
        field: 'custSourceText',
        width: '150px',
        showOverflow: true
      }, {
        title: '发货方',
        field: 'companyName',
        width: '150px',
        showOverflow: true
      }, {
        title: '报单金额',
        field: 'declarationPriceText',
        width: '150px',
        showOverflow: true
      }, {
        title: '备注',
        field: 'remark',
        width: '200px',
        showOverflow: true
      }, {
        title: '创建时间',
        field: 'createAt',
        width: '150px',
        showOverflow: true
      }, {
        title: '业务员',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '控销团队',
        field: 'supplierName',
        width: '150px',
        showOverflow: true
      }, {
        title: '所属分管',
        field: 'managerLinkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: '100px',
        fixed: 'right'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getReportList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              data.rows.forEach(item => {
                var _cusSourceList$find;

                item.state_text = item.state === '1' ? '已受理' : '未受理';
                item.deleteFlagText = item.deleteFlag === '1' ? '是' : '否';
                item.declarationPriceText = '￥' + item.declarationPrice;
                item.custSourceText = (_cusSourceList$find = cusSourceList.find(source => source.value === item.custSource)) === null || _cusSourceList$find === void 0 ? void 0 : _cusSourceList$find.label;
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function see(row) {
      selectRow.value = row;
      showDetail.value = true;
    }

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "客户名称",
              prop: "custName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.custName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.custName = $event),
                placeholder: "编码/名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发货方",
              prop: "companyName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.companyName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.companyName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员",
              prop: "supUser"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supUser,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.supUser = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "控销团队",
              prop: "supplier"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplier,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.supplier = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "客户来源",
              prop: "custSource"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.custSource,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.custSource = $event)
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cusSourceList, item => {
                  return _createVNode(_component_el_option, {
                    key: item.label,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态",
              prop: "state"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.state,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.state = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "已受理",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "未受理",
                  value: "0"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开始时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "结束时间",
              prop: "endTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "单据是否删除",
              prop: "deleteFlag"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.deleteFlag,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.deleteFlag = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "是",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "否",
                  value: "0"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[9] || (_cache[9] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "View",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(WechatRepoetDetailModal, {
        modelValue: showDetail.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showDetail.value = $event),
        data: selectRow.value
      }, null, 8, ["modelValue", "data"])]);
    };
  }

};